// extracted by mini-css-extract-plugin
module.exports = {"navbox":"Navbox_navbox__-hYnp","opened":"Navbox_opened__1NFCk"};